module.exports = __webpack_public_path__ + "img/ajio.2b42eedb.svg";